<template>
  <div class="card-list">
    <div class="card-list-item" v-for="(item, index) in list" :key="index">
      <slot :data="item"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
.card-list {
  &-item {
    // padding: 20px 0;
    &:not(:last-child) {
      border-bottom: 1px solid #f5f5f5;
    }
  }
}
</style>
